export const CHANGE_CURRENT_PAGE = 'categories/CHANGE_CURRENT_PAGE'
export const CHANGE_PAGE_SIZE = 'categories/CHANGE_PAGE_SIZE'
export const CREATE_CATEGORY = 'categories/CREATE_CATEGORY'
export const FETCH_CATEGORY = 'categories/FETCH_CATEGORY'
export const FETCH_CATEGORIES_LIST = 'categories/FETCH_CATEGORIES_LIST'
export const FETCH_CATEGORIES_FOR_OPTIONS = 'categories/FETCH_CATEGORIES_FOR_OPTIONS'
export const REMOVE_CATEGORY = 'categories/REMOVE_CATEGORY'
export const UPDATE_CATEGORY = 'categories/UPDATE_CATEGORY'
export const SET_PRODUCT_CATEGORIES = 'categories/SET_PRODUCT_CATEGORIES'
